import _ from 'lodash'
import { mapState } from 'vuex'
import useIdToFindCategory from '@/views/creative/utils/use-id-to-find-category'
import useIdToFindCategoryParent from '@/views/creative/utils/use-id-to-find-category-parent.js'
import { getBaseResourceType } from '@/store/creative/common/resource'

export const linkageMixin = {
  computed: {
    ...mapState({
      templateConfig: state => state.creative.template.templateConfig,
      isV2: state => state.creative.template.isV2
    }),

    expandCategory() {
      return this.templateConfig.category.find(item => item.id === 4)
    },

    expandCategorySubCategory() {
      return this.expandCategory && this.expandCategory.sub_category ? this.expandCategory.sub_category : []
    },

    allRefCategory() {
      const baseResourceType = getBaseResourceType(this.category.resource_type)
      // 优先读取 properties.refId（ps 产出的素材的文本节点关联关心存储在 properties 中）
      const prefix = _.get(this.category, 'properties.refId') || this.category.prefix
      return _.get(
        this.templateConfig,
        ['category_ref', baseResourceType, prefix],
        []
      ).filter(value => !this.expandCategorySubCategory.some(item => item.id === value)) // 过滤扩展内容中的关联元素
    },

    linkageId() {
      return this.allRefCategory.filter(item => {
        // 存在关联元素，且元素本身不在扩展内容中
        return Number(item) !== Number(this.category.id) && !this.expandCategorySubCategory.some(item => item.id === Number(this.category.id))
      }).join()
    },

    linkageCategory() {
      const arrayTemp = []
      if (this.linkageId) {
        this.linkageId.split(',').forEach(item => {
          arrayTemp.push(
            useIdToFindCategory({
              category: this.templateConfig.category,
              categoryId: Number(item)
            })
          )
        })
      }
      return arrayTemp
    },

    linkageCategoryText() {
      const arrayTemp = []
      if (this.linkageId) {
        this.linkageId.split(',').forEach(item => {
          const categoryParent = useIdToFindCategoryParent({
            category: this.templateConfig.category,
            categoryId: Number(item)
          }).reverse()
          // 删除第一层
          categoryParent.shift()
          arrayTemp.push(categoryParent.map(item => {
            return item.name
          }).join('-'))
        })
      }
      return arrayTemp.join(',')
    }
  }
}
